export default __webpack_public_path__ + "static/media/messaggi.87533567.png";